import { QRCode } from '@/components/qr-code'

export default function QRCodePage() {
  return <QRCode />
}
